<micro-lookup domain="access" obj="saLocks" url="/access/saLocks" [key]="saLockId" [link]="link"></micro-lookup>
